import { render } from "./QuestionSelectPartners.vue?vue&type=template&id=663b378d&scoped=true&ts=true"
import script from "./QuestionSelectPartners.vue?vue&type=script&lang=ts"
export * from "./QuestionSelectPartners.vue?vue&type=script&lang=ts"

import "./QuestionSelectPartners.vue?vue&type=style&index=0&id=663b378d&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663b378d"]])

export default __exports__